module.exports = __webpack_public_path__ + "static/media/valor2_3_3.1ecc7a6b.png";